import Vue from 'vue'
import App from '../App.vue'
import VueAnalytics from 'vue-analytics'
import LoadScript from 'vue-plugin-load-script'
import {redirectDirectAccess} from 'global/js/apps.js'
const config = require('../config.json')

Vue.config.productionTip = false
Vue.store = Vue.prototype.store = config
Vue.use(LoadScript)
Vue.loadScript('https://use.typekit.net/inp0asv.js')
.then(() => {
	try {
		window.Typekit.load({ async: true });
	}
	catch(e) {
		console.log('Error with Typescript:')
		console.log(e)
	}
})

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-15017861-10'
})

redirectDirectAccess(Vue.store.dzHostId, 'special')

new Vue({
  render: h => h(App),
}).$mount('#app')
